class OTPRequest{
    OTPurl(mobile,email,countryCode){
        return process.env.REACT_APP_BASEURL+"CreateOTPManual/"+mobile+"/"+email+"/"+countryCode;
    }
    OTPVerification(mobile,otp){
        return process.env.REACT_APP_BASEURL+"OtpVerificationManual/"+mobile+"/"+otp;
    }
}
export const {OTPurl,OTPVerification}=new OTPRequest()